import { Component, OnInit, Inject } from '@angular/core';
import { APP_CONFIG } from '../../app.config';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { VaultService } from '../../services/vault.service';
import { AuthService } from '../../services/auth.service';

import swal from 'sweetalert2';
import { CookieService } from 'ng2-cookies';
import { environment } from '../../../environments/environment.designly-uk.prod';
@Component({
  selector: 'app-vaultre-login',
  templateUrl: './vaultre-login.component.html',
  styleUrls: ['./vaultre-login.component.css']
})
export class VaultreLoginComponent implements OnInit {
  loading = false;
  login_link = '';
  code: '';

  vaultLoginSuccess = false;
  vaultLoginMessage = '';

  selectedLogo = '';
  redirectUrl = '';

  isUk = false;

  constructor(
    @Inject(APP_CONFIG) private appConfig,
    private route: ActivatedRoute,
    private router: Router,
    private vaultService: VaultService,
    public authService: AuthService
  ) { }

  ngOnInit() {
    if (this.appConfig.IS_UK && this.router.url === '/login') {
      this.router.navigateByUrl('/vaultea/login');
    }

    if ( String(this.router.url).includes('/vaultea/login') ) {
      this.redirectUrl = `${this.appConfig.HTML_ENDPOINT}/vaultea/login`;
      // tslint:disable-next-line:max-line-length
      this.login_link = 'https://login.vaultea.co.uk/cgi-bin/clientvault/oauth-authorize-user.cgi?client_id=' + this.appConfig.VAULT_UK_CLIENTID + '&redirect_uri=' + this.redirectUrl + '&response_type=code';
      this.isUk = true;
      this.vaultService.path = 'vaultea';
    } else {
      this.redirectUrl = `${this.appConfig.HTML_ENDPOINT}/login`;
      // tslint:disable-next-line:max-line-length
      this.login_link = 'https://login.vaultre.com.au/cgi-bin/clientvault/oauth-authorize-user.cgi?client_id=' + this.appConfig.VAULT_CLIENTID + '&redirect_uri=' + this.redirectUrl + '&response_type=code';
      this.isUk = false;
      this.vaultService.path = 'vault';
    }

    this.route.queryParams.subscribe(
      (params: Params) => {

        if ( params['RH'] === '1' ) {
          this.selectedLogo = 'Designplus_White.png';

          this.redirectUrl += '?RH=1';
          // tslint:disable-next-line:max-line-length
          this.login_link = 'https://login.vaultre.com.au/cgi-bin/clientvault/oauth-authorize-user.cgi?client_id=' + this.appConfig.VAULT_CLIENTID + '&redirect_uri=' + this.redirectUrl + '&response_type=code';
        } else {
          this.selectedLogo = 'designly-logo-inverted.svg';
        }

        this.vaultLoginMessage = params['reason'];
        if ( typeof this.vaultLoginMessage !== 'undefined' && this.vaultLoginMessage === 'success' ) {
          this.loading = true;
          this.code = params['code'];
          this.vaultLoginSuccess = true;

          this.vaultService.httpLogin({
            client_id: this.isUk ? this.appConfig.VAULT_UK_CLIENTID : this.appConfig.VAULT_CLIENTID,
            code: this.code
          });
        }
      }
    );

    this.vaultService.vaultAuthLogin.subscribe(
      (auth: any) => {
        if ( typeof auth !== 'undefined' && auth.status === 'success' ) {
          this.loading = false;
          this.authService.setAuthStorage(auth);
          const $this = this;

          swal({
            title: 'Preparing this device...',
            timer: 3000,
            onOpen: function () {
              swal.showLoading ();
            }
          }).then(
            function () {},
            // handling the promise rejection
            function (dismiss) {
              if (dismiss === 'timer') {
                window.location.href = '/campaigns';
              }
            }
          );
        }
        if ( typeof auth !== 'undefined' && auth.status === 'billingissue' ) {
          this.loading = false;
          swal(
            'Whoops, it looks like your subscription has not been paid.',
            'Please contact 1300 650 520 to arrange payment and get back to designing.',
            'error'
          );
        }
        if ( typeof auth !== 'undefined' && auth.status === 'blocked' ) {
          this.loading = false;

          swal({
            title: '',
            type: 'error',
            html:
              // tslint:disable-next-line:max-line-length
              '<p><strong>Doesn’t look like you have an account, please click <a target="_blank" href="https://websites.formstack.com/forms/designlyregistration">here</a> to enquire</strong></p>'
          });
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/vaultre-login/vaultre-login.component.ts